export const Styles: any = {
  ".successMessage": {
    "background": "#0ECF82 !important",
    "color": "#191919 !important",
    ".ms-MessageBar-content": {
      background: "#F2F2F2 !important",
      color: "#191919 !important",
    },
  },
  ".errorMessage": {
    "background": "#F2F2F2 !important",
    "color": "#191919 !important",
    ".ms-MessageBar-content": {
      background: "#F2F2F2 !important",
      color: "#191919 !important",
    },
  },
  ".warningMessage": {
    "background": "#F78A05 !important",
    "color": "#000000 !important",
    ".ms-MessageBar-content": {
      background: "#F78A05 !important",
      color: "#000000 !important",
    },
  },
  "messageStack": (MessageBarType: string) => {
    return {
      root: {
        "minHeight": "36px",
        "background": "#0ECF82 !important",
        "color": MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
        ".ms-MessageBar-content": {
          "background":
            MessageBarType === "success"
              ? "#0ECF82 !important"
              : MessageBarType === "error"
                ? "#E5505A !important"
                : "#F78A05 !important",
          "color": MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
          "alignItems": "center",
          ".ms-MessageBar-icon": {
            i: {
              color: MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
            },
          },
          ".ms-MessageBar-text": {
            "fontSize": "14px",
            "lineHeight": "18px",
            ".ms-MessageBar-innerText": {
              "width": "100%",
              "whiteSpace": "unset",
              ".ms-Stack": {
                justifyContent: "space-between",
              },
            },
          },
        },
      },
    };
  },
  "messageBar": {
    display: "none",
    backgroundColor: "transparent",
    borderRadius: "2px",
    minHeight: "36px",
  },
  "notificationMessage": {
    display: "flex",
    alignItems: "center",
  },
  "messageBarOn": {
    backgroundColor: "transparent",
    borderRadius: "2px",
    minHeight: "36px",
  },
};
